import script from "./distribution.vue?vue&type=script&setup=true&lang=ts"
export * from "./distribution.vue?vue&type=script&setup=true&lang=ts"

import "./distribution.vue?vue&type=style&index=0&id=8ba99846&scoped=true&lang=css"
import "./distribution.vue?vue&type=style&index=1&id=8ba99846&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ba99846"]])

export default __exports__